import { extendTheme, theme as base } from '@chakra-ui/react';
import { ElementsStyle as Elements } from './partials/elements/ElementsStyle';
import { BulletBankStyle as BulletBank } from './partials/elements/BulletBankStyle';
import { ErrorSpinnerPageStyle as ErrorPage } from './partials/components/ErrorSpinnerPageStyle';
import { ExpertiseStyle as Expertise } from './partials/elements/ExpertiseStyle';
import { ParserStyle as Parser} from '../formSections/Parser/ParserStyle';
import { PreviewStyle as Preview } from '../components/Preview/PreviewStyle';
import { AptitudeStyle as Aptitude} from '../formSections/Aptitude/AptitudeStyle';
import { NoteStyle as Notes} from '../components/Preview/components/Notes/NoteStyle';
import { InterviewStyle as Interview } from '../formSections/Interview/InterviewStyle';
import { PFSStyle as PFS } from '../components/ProgressiveFormStepper/PFSStyle';
import { ElementStyle as Element} from '../formElements/ElementStyle';
// import { ProgressStyle as Progress } from './partials/components/ProgressStyle';
import { ProTipStyle as ProTip } from './partials/components/ProTipStyle';
import { MultiSectionStyle as MultiSection } from './partials/controllers/MultiSectionStyle';
import { ButtonStyle as Button } from './partials/global/ButtonStyle';
import { HeadingStyle as Heading } from './partials/global/HeadingStyle';
import { TextStyle as Text } from './partials/global/TextStyle';
import { CheckboxStyle as Checkbox } from './partials/global/CheckboxStyle';
import { InputStyle as Input } from './partials/global/InputStyle';
import { SelectStyle as Select } from './partials/global/InputStyle';
import { RadioStyle as Radio } from './partials/global/InputStyle';
import { HeaderStyle as Header } from '../components/SiteHeader/HeaderStyle';
import { PreviewLetterStyle as PreviewLetter } from '../components/PreviewLetter/PreviewLetterStyle';

const rstheme = extendTheme({
  // Fonts
  fonts: {
    body: `Work Sans, ${base.fonts.heading}`,
    heading: `Work Sans, ${base.fonts.heading}`,
    text: 'Work Sans',
    link: 'Work Sans',
  },
  // Colors
  colors: {
    WHITE: '#FFFFFF',
    BLACK: '#333333',
    BLACKER: '#29292A',

    //grays
    GRAY: '#C4C4C4', //Border color
    //#989898
    GRAY_2: '#707070', //Gray text/icon color
    GRAY_DARK: '#2D3748', //Near black text
    GRAY_LIGHT: '#F2EFEF',
    NAVY: '#2542BB',
    NAVY_LIGHT: '#2542BB',
    NAVY_EXTRA_LIGHT: '#e5e9fa',
    NAVY_HOVER: '#162b7d',
    ORANGE: '#FF914D',
    ORANGE_TEXT: '#e65800',
    ORANGE_LIGHT: '#FEEBC8',
    ORANGE_DARK: '#e65800',
    ORANGE_HOVER: '#e65800',
    MAGENTA: '#BD1D76',
    RED: '#FF0000',
    BLUE: '#0000FF',
    orangeScheme: {
      100: '#FF914D',
      500: '#FF914D',
      900: '#e65800',
    },
  },
  // Components
  components: {
    Header,
    ProTip,
    Preview,
    PreviewLetter,
    PFS,
    Element,
    Expertise,
    MultiSection,
    ErrorPage,
    Parser,
    Aptitude,
    Interview,
    Notes,
    Elements,
    BulletBank,
    Button,
    Heading,
    Text,
    Checkbox,
    Input,
    Select,
    Radio,
  },
});

export default rstheme;
